<template>
  <v-dialog fullscreen persistent scrollable v-model="dialog">
    <v-card id="qj-dialog-view">
      <!-- Cabeçalho -->
      <v-card-title class="pa-0">
        <v-toolbar tabs dense prominent extended style="z-index: 1" class="elevation-2">
          <v-toolbar-title> {{ this.creditor.name }}</v-toolbar-title>
          <v-toolbar-title>
            <!-- Caminho -->
            <v-breadcrumbs :items="breadcrumb" class="pa-0 ma-0">
              <template v-slot:divider>
                <v-icon>chevron_right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  class="subheading purple--text"
                  style="cursor: default"
                >
                  {{ item.text.toUpperCase() }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="$emit('update:dialog', false)">
            <v-icon>close</v-icon>
          </v-btn>
          <template v-slot:extension>
            <v-tabs color="transparent" slider-color="primary" v-model="tabs">
              <v-tab ripple> Geral </v-tab>
              <v-tab ripple> Não localizados </v-tab>
              <v-tab ripple> Localizados </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
      </v-card-title>
      <!-- Corpo -->
      <v-card-text style="min-height: calc(100vh - 96px)" class="grey lighten-5">
        <v-tabs-items v-model="tabs" slider-color="primary">
          <!-- Tab 1 -->
          <v-tab-item>
            <v-container fluid grid-list-lg class="pa-0">
              <v-layout row wrap>
                <!-- Gráfico -->
                <v-flex xs12>
                  <v-card>
                    <v-card-text class="pa-0">
                      <GeneralChart ref="generalChart" :data="history" />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Informações -->
                <v-flex xs12>
                  <v-card>
                    <v-card-title primary-title>
                      <div>
                        <h3 class="font-weight-medium title">
                          {{ data.last_resolution.customers | numeral("0,0") }}
                          clientes
                        </h3>
                        <p class="font-weight-medium subheading">
                          {{ data.last_resolution.incoming | numeral("0,0") }}
                          oxigenados
                        </p>
                      </div>
                      <v-spacer />
                      <div class="grey--text text--darken-2">
                        Atualizado em: <br />
                        {{ data.updated_at | formatDateTime }}
                      </div>
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                      <!-- Informações -->
                      <v-layout row wrap>
                        <!-- Não localizados -->
                        <v-flex xs12 md6>
                          <TreeNotLocated :data="data.last_resolution" />
                        </v-flex>
                        <!-- Localizados -->
                        <v-flex xs12 md6>
                          <TreeLocated :data="data.last_resolution" />
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico X -->
                <!-- <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Acionamento</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <XChart ref="xChart" :data="data" />
                    </v-card-text>
                  </v-card>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-tab-item>
          <!-- Tab 2 -->
          <v-tab-item>
            <v-container fluid grid-list-lg class="pa-0">
              <v-layout row wrap>
                <!-- Gráfico bar acionamento -->
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Acionamento</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <ActuationBarChart
                        ref="notLocatedActuationBarChart"
                        :data="history"
                        :located="false"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico bar variables not hot -->
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Variáveis por clientes acionáveis (%)</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <VariablesBarChart
                        ref="notLocatedVariablesBarChart"
                        :data="data.last_resolution"
                        :located="false"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico pizza qualidade de celulares -->
                <v-flex xs12 md6>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Qualidade de Celulares</h3>
                      <v-spacer />
                      <!-- <v-btn
                        small
                        outline
                        class="ma-0"
                        color="indigo"
                        @click="window.open('https://www.google.com/', '_blank')"
                      >
                        Metabase<v-icon small class="ml-1">mdi-open-in-new</v-icon>
                      </v-btn> -->
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <NotLocatedPieChart
                        ref="notLocatedPieChart"
                        :data="data.last_resolution"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico pizza credores -->
                <v-flex xs12 md6>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Credores</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <CreditorPieChart
                        ref="notLocatedCreditorPieChart"
                        :located="false"
                        :data="data.last_resolution"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico pizza canais -->
                <v-flex xs12 md6>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Canais</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <ValidChannelsPieChart
                        ref="notLocatedValidChannelsPieChart"
                        :located="false"
                        :data="data.last_resolution"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico pizza distribuição dos canais -->
                <v-flex xs12 md6>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Distribuição dos Canais</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <ChannelsPieChart
                        ref="notLocatedChannelsPieChart"
                        :located="false"
                        :data="data.last_resolution"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <!-- Tab 3 -->
          <v-tab-item>
            <v-container fluid grid-list-lg class="pa-0">
              <v-layout row wrap>
                <!-- Gráfico bar acionamento -->
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Acionamento</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <ActuationBarChart ref="locatedActuationBarChart" :data="history" />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico bar variables hot -->
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Variáveis por clientes acionáveis (%)</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <VariablesBarChart ref="locatedVariablesBarChart" :data="data.last_resolution" :located="true"/>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico pizza credores -->
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Credores</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <CreditorPieChart
                        ref="locatedCreditorPieChart"
                        :data="data.last_resolution"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico pizza canais -->
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Canais</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <ValidChannelsPieChart
                        ref="locatedValidChannelsPieChart"
                        :data="data.last_resolution"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Gráfico pizza distribuição dos canais -->
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <v-card-title>
                      <h3 class="headline mb-0">Distribuição dos Canais</h3>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <ChannelsPieChart
                        ref="locatedChannelsPieChart"
                        :data="data.last_resolution"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import util from "../utils/util";
import utilChart from "../utils/chart";
import TreeLocated from "../trees/treeLocated";
import GeneralChart from "../charts/generalChart";
import TreeNotLocated from "../trees/treeNotLocated";
import VariablesBarChart from "../charts/variablesBarChart.vue";
import ChannelsPieChart from "../charts/channelsPieChart";
import CreditorPieChart from "../charts/creditorPieChart";
import XChart from "../charts/xChart";
import ActuationBarChart from "../charts/actuationBarChart";
import NotLocatedBarChart from "../charts/notLocatedBarChart";
import NotLocatedPieChart from "../charts/notLocatedPieChart";
import ValidChannelsPieChart from "../charts/validChannelsPieChart";

export default {
  props: ["data", "dialog", "creditor"],
  components: {
    XChart,
    TreeLocated,
    GeneralChart,
    TreeNotLocated,
    VariablesBarChart,
    ChannelsPieChart,
    CreditorPieChart,
    ActuationBarChart,
    NotLocatedBarChart,
    NotLocatedPieChart,
    ValidChannelsPieChart,
  },
  data() {
    return {
      tabs: 0,
      qualityLocated: "good",
      qualityNotLocated: "good",
      qualities: [
        { text: "Qualidade Boa", value: "good" },
        { text: "Qualidade Média", value: "avg" },
        { text: "Qualidade Ruim", value: "bad" },
      ],
    };
  },
  mounted() {
    let vm = this;
    "zoom resize".split(" ").forEach(function (e) {
      window.addEventListener(e, () => vm.refreshGraphs());
    });
  },
  computed: {
    breadcrumb() {
      if (!this.data.parent) return [];
      return util.mountBreadCrumb(this.data.parent);
    },
    history() {
      setTimeout(() => this.refreshGraphs(), 200);
      if (!this.data.history) return [];
      return this.data.history
        .reverse()
        .slice(Math.max(this.data.history.length - utilChart.periods, 0));
    },
  },
  watch: {
    tabs() {
      setTimeout(() => this.refreshGraphs(), 200);
    },
    dialog() {
      if (this.dialog) this.tabs = 0;
    },
  },
  methods: {
    refreshGraphs() {
      utilChart.refs.forEach((ref) => {
        if (typeof this.$refs == "undefined") return;
        if (typeof this.$refs[ref] == "undefined") return;
        if (typeof this.$refs[ref].$refs == "undefined") return;
        if (typeof this.$refs[ref].$refs.chart == "undefined") return;
        this.$refs[ref].$refs.chart.resize();
      });
    },
  },
};
</script>

<style>
.v-breadcrumbs__item {
  cursor: default !important;
}

#qj-dialog-view .v-toolbar__content {
  padding-right: 0;
}
#qj-dialog-view .v-toolbar__content > :last-child.v-btn--icon {
  margin-right: 6px;
}

.qj-echarts.echarts {
  width: 100%;
  height: 500px;
}
.charts div,
.charts .echarts canvas {
  max-width: 100%;
}
.qj-dense-outline.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 44px !important;
}
.qj-dense-outline.v-text-field.v-text-field--enclosed .v-input__prepend-inner,
.qj-dense-outline.v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 8px !important;
}
</style>
